require('./myProfileKeysSignatureEnd.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
//@constants
const { SUCCESS_SCREEN_PROPS } = require('../constants/myProfileKeysSignatureProps');
const biocatch = require('constants/biocatch');

// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");

const MyProfileKeysSignatureEnd = ({ lowBiocatchAvailable }) => {
    const exitLink = `/myProfile`;
    const goBackButtonLabel = formatText('signatureEdit-successLink').toUpperCase();
    const title = formatText(SUCCESS_SCREEN_PROPS[lowBiocatchAvailable].title);
    const goBackButton = {
        label: goBackButtonLabel,
        url: exitLink
    }

    React.useEffect(()=>{
        changeBiocatchContext(biocatch.CONFIRMATION_PAGE)
    },[])
    
    return (
        <WizardSuccess
            successMessage={title}
            mainButton={goBackButton}
        >
            <p className="access-key-change-success__caption">
                <FormattedText value={SUCCESS_SCREEN_PROPS[lowBiocatchAvailable].subtitle} />
            </p>
        </WizardSuccess>
    );
};

MyProfileKeysSignatureEnd.propTypes = {
    lowBiocatchAvailable: PropTypes.string.isRequired
  };

module.exports = MyProfileKeysSignatureEnd;
